<template>
  <div class="newMenu">
    <div class="home-con">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="first">
          <span slot="label">
            <img class="first-img-type" src="https://cdn.ideamake.cn/sw-pc/images/new-capabilities-type.png" alt="">
            <p class="label-tit">新功能</p>
          </span>
          <div class="home-con-item">
            <div class="first-word">
              <div class="first-word-big">
                以创新驱动营销增长
              </div>
              <div class="first-word-small">
                <div class="first-word-small-item first-word-small1">
                  BI：基于成交结果，分析项目营销效果，赋能最理解场景需求的标准/定制化业绩解码看板
                </div>
                <div class="first-word-small-item first-word-small2">
                  AI：基于人工智能算法，针对客户全生命周期进行数据自动采集和分析
                </div>
                <div class="first-word-small-item first-word-small3">
                  MA：基于客户行为，潜客分层分群运营，自动化培育转化
                </div>
              </div>
            </div>
            <div class="tab-img-box">
              <img class="first-img first-img1" src="https://cdn.ideamake.cn/sw-pc/images/new-capabilities.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label">
            <img class="first-img-type" src="https://cdn.ideamake.cn/sw-pc/images/new-play-type.png" alt="">
            <p class="label-tit">新打法</p>
          </span>
          <div class="home-con-item">
            <div class="first-word">
              <div class="first-word-big">
                面向下一代的数字化营销解决方案
              </div>
              <div class="first-word-small">
                <div class="first-word-small-item first-word-small1">
                  客户获取：打造行业最优增长模型，持续提供规模化获客方案
                </div>
                <div class="first-word-small-item first-word-small1">
                  运营识别：精细化用户洞察和分层运营，持续激活用户，实现用户价值最大化
                </div>
                <div class="first-word-small-item first-word-small1">
                  客户转化：提供全渠道统一判客，佣金灵活组合的案场营销管理产品
                </div>
              </div>
            </div>
            <div class="tab-img-box">
              <img class="first-img first-img1" src="https://cdn.ideamake.cn/sw-pc/images/new-play.png" alt="">
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="third">
          <span slot="label">
            <img class="first-img-type" src="https://cdn.ideamake.cn/sw-pc/images/new-organization-type.png" alt="">
            <p class="label-tit">新组织</p>
          </span>
          <div class="home-con-item">
            <div class="first-word">
              <div class="first-word-big">
                以陪伴助力企业进化
              </div>
              <div class="first-word-small">
                <div class="first-word-small-item first-word-small1">
                  持续地围绕客户迭代，和行业一同进化<br>
                  更好的客户，更好的产品，更好地沉淀最佳实践
                </div>
              </div>
            </div>
            <div class="tab-img-box">
              <img class="first-img first-img1" src="https://cdn.ideamake.cn/sw-pc/images/new-organization.png" alt="">
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: 'new-menu',
  data () {
    return {
      activeName: 'first',
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  }
}
</script>
<style lang="scss" scoped>
.newMenu{
  .home-con{
          margin: 0 auto;
          width: 1200px;
          padding: 65px 0 100px;
          height: 718px;
          .home-con-item{
              display: flex; 
              justify-content: space-between;
              // padding-top: 40px;
              .first-word {
                  padding: 70px 0 0 20px;
                  .first-word-big{
                      color: #2D2E30;
                      font-size: 28px;
                      font-family: PingFangSC-Semibold, PingFang SC;
                      font-weight: 600;
                      margin-bottom: 23px;
                  }
                  .first-word-small{
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #2D2E30;
                      font-size: 14px;
                      width: 420px;
                      .first-word-small-item{
                          margin-bottom: 12px;
                      }
                      .first-word-small1{
                          position: relative;
                          line-height: 24px;
                      }
                      .first-word-small1::before{
                          content: '';
                          display: inline-block;
                          width: 8px;
                          height: 8px;
                          background: #5D81FF;
                          position: absolute;
                          left: -15px;
                          top: 8px;
                      }
                      .first-word-small2{
                          position: relative;
                          line-height: 24px;
                      }
                      .first-word-small2::before{
                          content: '';
                          display: inline-block;
                          width: 8px;
                          height: 8px;
                          background: #7B84EA;
                          position: absolute;
                          left: -15px;
                          top: 8px;
                      }
                      .first-word-small3{
                          position: relative;
                          line-height: 24px;
                      }
                      .first-word-small3::before{
                          content: '';
                          display: inline-block;
                          width: 8px;
                          height: 8px;
                          background: #54C3A5;
                          position: absolute;
                          left: -15px;
                          top: 8px;
                      }
                  }
              }
              .first-img{
                  width: 722px;
                  height: 448px;
              }
              .first-img1{
                  width: 712px;
                  height: 391px;
              }
          }
          .first-img-type{
              width: 64px;
              height: 70px;
              display: inline-block;
          }
          ::v-deep .el-tabs{
              .el-tabs__header{
                  display: flex;
                  justify-content: center;
                  margin: 0 0 55px;
                  .el-tabs__nav{
                    display: flex;
                    align-items: flex-end;
                  }
              }
              .el-tabs__item {
                  width: 196px;
                  height: 80px;
                  text-align: center;
                  background: linear-gradient(180deg, #F3F5F7 0%, #FFFFFF 100%);
                  border: 1.5px solid #FFFFFF;
                  box-shadow: 0px 4px 12px 0px rgba(155,165,192,0.25), inset 0px 1px 3px 0px rgba(0,0,0,0.03);
                  line-height: 80px;
                  margin-right: 68px;
                  &:hover{
                    color:#3777F6;
                  }
              }
              .el-tabs__nav-scroll {
                  overflow: initial;
                  .el-tabs__nav{
                      padding-bottom: 25px;
                      .el-tabs__active-bar{
                        background-color: #F7F9FB;
                      }
                  }
                  
              }
              .el-tabs__nav-wrap{
                  padding-top: 12px;
              }
              
              .el-tabs__nav-wrap::after{
                  background-color: #F7F9FB;
              }
              .is-active{
                height: 86px !important;
                line-height: 86px !important;
              }
              .is-active span{
                color: rgb(55, 119, 246);
              }
              span{
                display: flex;
                justify-content: center;
                align-items: center;
                .label-tit{
                  margin-left: 4px;
                }
              }
              .is-active::after{
                  content:url('https://cdn.ideamake.cn/sw-pc/images/type.png');
                  display: inline-block;
                  width: 20px;
                  height: 20px;
                  position: absolute;
                  right: 0px;
                  top: -30px;
              }
              .is-active::before{
                  content: '';
                  height: 3px;
                  width: 194px;
                  background: #3777F6;
                  display: inline-block;
                  vertical-align: middle;
                  position: absolute;
                  bottom: -1px;
                  left: 0;
              }
                  
          }
          
      }
}
// 移动端布局
@import "../min-home";
</style>
  